import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Add, Trash } from "iconsax-react";
import { memo } from "react";

import type { SefanoButtonProps } from "./SefanoButton.types";
import * as styles from "./SefanoButton.styles";

export type { SefanoButtonProps } from "./SefanoButton.types";

export const SefanoButton = memo(function SefanoButton({
  intent = "primary",
  children,
  fullWidth = false,
  startIcon,
  size = "medium",
  sx,
  ...buttonProps
}: SefanoButtonProps) {
  const theme = useTheme();

  const color =
    intent === "danger" ? "error" : intent === "secondary" || intent === "cancel" ? "secondary" : "primary";
  const resolvedStartIcon =
    startIcon ??
    (intent === "add" ? (
      <Add size={size === "small" ? 18 : 20} variant="Linear" color={theme.palette.primary.contrastText} />
    ) : intent === "cancel" ? (
      <Trash size={20} variant="Linear" color={theme.palette.secondary.contrastText} />
    ) : undefined);

  const intentStyles = styles.root(intent, size);
  const resolvedIntentStyles =
    typeof intentStyles === "function" ? intentStyles(theme) : intentStyles;

  const mergedSx = {
    ...resolvedIntentStyles,
    ...(fullWidth ? styles.fullWidth : {}),
    ...(typeof sx === "function" ? sx(theme) : sx && !Array.isArray(sx) ? sx : {}),
  };

  return (
    <Button
      variant={intent === "danger" ? "outlined" : "contained"}
      color={color}
      size={size}
      fullWidth={fullWidth}
      startIcon={resolvedStartIcon}
      sx={mergedSx}
      {...buttonProps}
    >
      {children}
    </Button>
  );
});
